import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col m-2 lg:flex-row gap-2 lg:gap-10 lg:my-4 text-sm" }
const _hoisted_2 = { class: "lg:w-1/2 lg:mr-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-grisTitle" }, "Distribución de pago anterior", -1)
const _hoisted_5 = {
  class: "border-collapse border-2 border-bg-borderGris table-auto w-full mt-3",
  "aria-describedby": "table-previous-payment"
}
const _hoisted_6 = { class: "border bg-grisTwo" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "text-left pl-4 w-3/5 text-grisTitle" }, " Fecha Pago Anterior ", -1)
const _hoisted_8 = { class: "text-right pr-10 text-grisTitle" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4 pt-2" }, " Abono a Capital ", -1)
const _hoisted_10 = { class: "text-right pr-10 pt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Intereses Corrientes ", -1)
const _hoisted_12 = { class: "text-right pr-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Intereses Mora ", -1)
const _hoisted_14 = { class: "text-right pr-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Seguro de Vida ", -1)
const _hoisted_16 = { class: "text-right pr-10" }
const _hoisted_17 = { class: "border-x-2 border-bgborderGris pl-4" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "text-right pr-10" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4 pb-2" }, " Menos Alivios Intereses ", -1)
const _hoisted_22 = { class: "text-right pr-10 pb-2" }
const _hoisted_23 = { class: "bg-grisTwo" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris font-bold pl-4 text-grisTitle" }, " Total: ", -1)
const _hoisted_25 = { class: "text-right font-bold pr-10 text-grisTitle" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-grisTitle" }, "Estado actual de su crédito")
], -1)
const _hoisted_27 = {
  class: "border-collapse border-2 border-bgborderGris table-auto w-full mt-3",
  "aria-describedby": "current-credit-status"
}
const _hoisted_28 = { class: "bg-grisTwo" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "text-left pl-4 w-3/5 print:text-xs" }, " Saldo total a la fecha ", -1)
const _hoisted_30 = { class: "text-right pr-10" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4 pt-2" }, " Plazo Total ", -1)
const _hoisted_32 = { class: "text-right pr-10 pt-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Cuotas Pendientes ", -1)
const _hoisted_34 = { class: "text-right pr-10" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Cuotas Facturadas ", -1)
const _hoisted_36 = { class: "text-right pr-10" }
const _hoisted_37 = { class: "border-b-2 border-bgborderGris" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4 pb-2" }, " Cuotas en Mora ", -1)
const _hoisted_39 = { class: "text-right pr-10 pb-2" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { class: "border-x border-bgborderGris pl-4 pt-2" }, " Tasa de Interés Pactada ", -1)
const _hoisted_42 = { class: "text-right pr-10 pt-2" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "border-x border-bgborderGris pl-4" }, " Tasa de Interés Cobrada ", -1)
const _hoisted_45 = { class: "text-right pr-10" }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "border-x border-bgborderGris pl-4 pb-2" }, " Tasa de Mora Vigente ", -1)
const _hoisted_48 = { class: "text-right pr-10 pb-2" }
const _hoisted_49 = {
  key: 1,
  class: "flex flex-col gap-2 mt-4"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "bg-grisTwo rounded-lg py-2 px-6 h-56 flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "p-2 text-xs md:text-sm font-bold" }, " Consulte el estado y la evolución de su obligación, el detalle de su plan de pagos, el histórico de pagos realizados y mucho más ingresando a nuestra sucursal virtual. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://sucursalvirtual.refinancia.co/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    /*#__PURE__*/_createElementVNode("button", { class: "bg-primary text-white h-8 w-36 rounded-full font-bold text-xs md:text-sm" }, " Ingrese aqui ")
  ])
], -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "lg:w-1/2 items-end lg:mt-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_54 = { class: "w-full flex bg-grisTable text-white p-2" }
const _hoisted_55 = { class: "w-1/2 px-4 print:px-0" }
const _hoisted_56 = {
  key: 0,
  class: "font-bold print:text-xs"
}
const _hoisted_57 = {
  key: 1,
  class: "font-bold print:text-xs"
}
const _hoisted_58 = { class: "w-1/2 text-right px-4 print:px-0" }
const _hoisted_59 = { class: "font-bold print:text-xs" }
const _hoisted_60 = { class: "grid grid-cols-1 lg:grid-cols-2 mt-2 gap-4" }
const _hoisted_61 = { class: "lg:py-4 lg:px-4" }
const _hoisted_62 = { class: "flex justify-between p-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary print:text-xs" }, "Pague Hasta", -1)
const _hoisted_64 = { class: "print:text-xs font-bold text-gris80" }
const _hoisted_65 = { class: "flex justify-between p-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-grisTitle print:text-xs" }, " Fecha de facturación ", -1)
const _hoisted_67 = { class: "print:text-xs text-gris80" }
const _hoisted_68 = {
  key: 0,
  class: "lg:py-4"
}
const _hoisted_69 = { class: "flex justify-between p-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-grisTitle print:text-xs" }, " Valor asegurado ", -1)
const _hoisted_71 = { class: "print:text-xs" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold mt-2 print:text-xs" }, " Recuerde que es importante pagar en la fecha estipulada para no generar mora ", -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { key: 1 }
const _hoisted_76 = {
  key: 0,
  class: "text-xs font-bold mt-2 print:text-xs"
}
const _hoisted_77 = {
  key: 1,
  class: "text-xs font-bold mt-2 print:text-xs"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "w-full items-start mt-8 mb-2 print:mt-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-grisTitle" }, "Distribución de la cuota a pagar")
], -1)
const _hoisted_79 = {
  key: 2,
  class: "w-full"
}
const _hoisted_80 = {
  class: "border-collapse border-2 border-bg-borderGris table-auto w-full",
  "aria-describedby": "Quota distribution"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4 pt-2" }, " Abono a Capital ", -1)
const _hoisted_82 = { class: "text-right pr-10 pt-2" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Intereses Corrientes ", -1)
const _hoisted_84 = { class: "text-right pr-10" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Intereses Mora ", -1)
const _hoisted_86 = { class: "text-right pr-10" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Seguro de Vida ", -1)
const _hoisted_88 = { class: "text-right pr-10" }
const _hoisted_89 = { class: "border-x-2 border-bgborderGris pl-4" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { class: "text-right pr-10" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4 pb-2" }, " Menos Alivios Intereses ", -1)
const _hoisted_94 = { class: "text-right pr-10 pb-2" }
const _hoisted_95 = { class: "bg-grisTwo" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris font-bold pl-4" }, " Total: ", -1)
const _hoisted_97 = { class: "text-right font-bold pr-10" }
const _hoisted_98 = {
  key: 3,
  class: "w-full"
}
const _hoisted_99 = {
  class: "border-collapse border-2 border-bg-borderGris table-auto w-full",
  "aria-describedby": "Quota distribution"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4 pt-2" }, "Capital", -1)
const _hoisted_101 = { class: "text-right pr-10 pt-2" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, [
  /*#__PURE__*/_createTextVNode(" Intereses Corrientes "),
  /*#__PURE__*/_createElementVNode("sup", null, "3")
], -1)
const _hoisted_103 = { class: "text-right pr-10" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Intereses Mora ", -1)
const _hoisted_105 = { class: "text-right pr-10" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, [
  /*#__PURE__*/_createTextVNode(" Seguro de Vida "),
  /*#__PURE__*/_createElementVNode("sup", null, "5")
], -1)
const _hoisted_107 = { class: "text-right pr-10" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4" }, " Cargos Adtivos Cobranza ", -1)
const _hoisted_109 = { class: "text-right pr-10" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris pl-4 pb-2" }, [
  /*#__PURE__*/_createTextVNode(" Intereses Alivios "),
  /*#__PURE__*/_createElementVNode("sup", null, "4")
], -1)
const _hoisted_111 = { class: "text-right pr-10 pb-2" }
const _hoisted_112 = { class: "bg-grisTwo" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("td", { class: "border-x-2 border-bgborderGris font-bold pl-4" }, " Total: ", -1)
const _hoisted_114 = { class: "text-right font-bold pr-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isLince)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.data.fecha_pago_anterior === '1900-01-01'
                    ? '-'
                    : _ctx.$filters.formatDate(_ctx.data.fecha_pago_anterior)), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$filters.currency(_ctx.data.capital_pago_anterior)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$filters.currency(_ctx.data.interes_corriente_pago_anterior)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_13,
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$filters.currency(_ctx.data.interes_mora_pago_anterior)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_15,
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$filters.currency(_ctx.data.seguro_vida_pago_anterior)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_17, [
                    (_ctx.isIris)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Gastos Administrativos de Cobranza + IVA"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, "Cargos Adtivos Cobranza"))
                  ]),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$filters.currency(_ctx.data.gac_pago_anterior)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_21,
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$filters.currency(_ctx.data.alivios_pago_anterior)), 1)
                ]),
                _createElementVNode("tr", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$filters.currency(_ctx.data.valor_total_pago_anterior)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(!_ctx.isLince ? 'mt-4 mb-6' : '')
      }, [
        _hoisted_26,
        _createElementVNode("table", _hoisted_27, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$filters.currency(_ctx.data.total_saldo_capital)), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_31,
              _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.data.plazo_inicial), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_33,
              _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.data.cuotas_pendientes), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_35,
              _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.data.cuotas_facturadas), 1)
            ]),
            _createElementVNode("tr", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.data.cuotas_en_mora), 1)
            ]),
            (!_ctx.isLince)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.financial(_ctx.data.tasa_interes_pactada)) + " % ", 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isLince)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.financial(_ctx.data.tasa_interes_cobrada)) + " % ", 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isLince)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.financial(_ctx.data.tasa_mora_vigente)) + " % ", 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2),
      (_ctx.isLince)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_52, [
      _hoisted_53,
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("span", _hoisted_55, [
          (_ctx.isIris)
            ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Total a Pagar Cuota (Pago Mínimo)"))
            : (_openBlock(), _createElementBlock("span", _hoisted_57, "Total a pagar"))
        ]),
        _createElementVNode("span", _hoisted_58, [
          _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$filters.currency(_ctx.data.valor_pagar_actual)), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.inDefault(_ctx.data)), 1)
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$filters.formatDate(_ctx.data.fecha_facturacion)), 1)
            ])
          ]),
          (_ctx.data.fondeador_id != '1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.$filters.currency(_ctx.data.valor_desambolso)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.data.fondeador_id === '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_74))
        : _createCommentVNode("", true),
      (_ctx.data.fondeador_id === '2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
            (+_ctx.data.cuotas_en_mora > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_76, " Su credito presenta mora. Si pasados 20 dias calendario desde la fecha de envio de este extracto persiste el incumplimiento, el banco realizara el reporte negativo a las centrales por el tiempo que indica la ley. "))
              : (_openBlock(), _createElementBlock("p", _hoisted_77, " Felicidades su credito continua al dia. Recuerde que realizar sus pagos oportunamente lo califican como un excelente cliente. "))
          ]))
        : _createCommentVNode("", true),
      _hoisted_78,
      (!_ctx.isLince)
        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
            _createElementVNode("table", _hoisted_80, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_81,
                  _createElementVNode("td", _hoisted_82, _toDisplayString(_ctx.$filters.currency(_ctx.data.capital_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_83,
                  _createElementVNode("td", _hoisted_84, _toDisplayString(_ctx.$filters.currency(_ctx.data.interes_corriente_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_85,
                  _createElementVNode("td", _hoisted_86, _toDisplayString(_ctx.$filters.currency(_ctx.data.interes_mora_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_87,
                  _createElementVNode("td", _hoisted_88, _toDisplayString(_ctx.$filters.currency(_ctx.data.seguro_vida_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_89, [
                    (_ctx.isIris)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Gastos Administrativos de Cobranza + IVA"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_91, "Cargos Adtivos Cobranza"))
                  ]),
                  _createElementVNode("td", _hoisted_92, _toDisplayString(_ctx.$filters.currency(_ctx.data.gac_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_93,
                  _createElementVNode("td", _hoisted_94, _toDisplayString(_ctx.$filters.currency(_ctx.data.alivios_pago_actual)), 1)
                ]),
                _createElementVNode("tr", _hoisted_95, [
                  _hoisted_96,
                  _createElementVNode("td", _hoisted_97, _toDisplayString(_ctx.$filters.currency(_ctx.data.valor_pagar_actual_1)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLince)
        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
            _createElementVNode("table", _hoisted_99, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_100,
                  _createElementVNode("td", _hoisted_101, _toDisplayString(_ctx.$filters.currency(_ctx.data.capital_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_102,
                  _createElementVNode("td", _hoisted_103, _toDisplayString(_ctx.$filters.currency(_ctx.data.interes_corriente_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_104,
                  _createElementVNode("td", _hoisted_105, _toDisplayString(_ctx.$filters.currency(_ctx.data.interes_mora_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_106,
                  _createElementVNode("td", _hoisted_107, _toDisplayString(_ctx.$filters.currency(_ctx.data.seguro_vida_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_108,
                  _createElementVNode("td", _hoisted_109, _toDisplayString(_ctx.$filters.currency(_ctx.data.gac_pago_actual)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_110,
                  _createElementVNode("td", _hoisted_111, _toDisplayString(_ctx.$filters.currency(_ctx.data.alivios_pago_actual)), 1)
                ]),
                _createElementVNode("tr", _hoisted_112, [
                  _hoisted_113,
                  _createElementVNode("td", _hoisted_114, _toDisplayString(_ctx.$filters.currency(_ctx.data.valor_pagar_actual_1)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}